import {
  fetchGetMegaPageData,
  fetchGetMegaPage,
  fetchGetMegaPages,
} from "./queries";

const getMegaPages = async (data) => {
  try {
    const result = await fetchGetMegaPages(data);

    if (result.message) {
      return { success: false, message: result.message };
    }

    return { ...result, success: true };
  } catch (error) {
    return { success: false, message: "Get Mega Pages failed" };
  }
};

const getMegaPage = async (link) => {
  try {
    const result = await fetchGetMegaPage(link);

    if (result.message) {
      return result;
    }
    return { success: true, megaPage: result.megaPage };
  } catch (error) {
    return { success: false, message: "Get Mega Page failed" };
  }
};

const getMegaPageData = async (id) => {
  try {
    const result = await fetchGetMegaPageData(id);

    if (result.message) {
      return result;
    }

    return { success: true, megaPageData: result.seoData };
  } catch (error) {
    return { success: false, message: "Get Mega Page data failed" };
  }
};

export { getMegaPages, getMegaPage, getMegaPageData };
